import https from "https";

import axios from "axios";

import { handleUnauthenticated } from "@/apis/interceptors/handleUnauthenticated";
import { handleXsrfTokenMismatch } from "@/apis/interceptors/handleXsrfTokenMismatch";

export const getBaseUri = (): string =>
  process.env.NEXT_PUBLIC_API_BASE_URL as string;

const axiosInstance = axios.create({
  validateStatus: (status) => status < 500, // 500未満のステータスでは例外を投げない
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
  withCredentials: true,
});

axiosInstance.defaults.httpsAgent = new https.Agent({
  rejectUnauthorized:
    !process.env.NEXT_PUBLIC_HTTP_CLIENT_ALLOW_UNAUTHENTICATED,
});

axiosInstance.interceptors.response.use(handleUnauthenticated());
axiosInstance.interceptors.response.use(handleXsrfTokenMismatch());

export const getAxiosInstance = () => axiosInstance;
